import templateUrl from './edit-product-order-status-modal.component.html';

export const EditProductOrderStatusModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexEditProductOrderStatusModal",
    size: 'sm',
    backdrop: 'static'
}

export const EditProductOrderStatusModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: class {

        constructor($q, workOrderService, utilityService) {
            'ngInject'
            this.workOrderService = workOrderService;
            this.utilityService = utilityService;
            this.$q = $q;
        }
        $onInit() {

        }

        $onChanges(changesObj) {
            if (changesObj.resolve) {
                this.workOrder = this.resolve.workOrder;
                this.productOrder = this.resolve.productOrder;
                this.productOrderStatuses = this.resolve.productOrderStatuses;
            }
        }

        onCancel() {
            this.dismiss({ $value: 'cancel' });
        }

        onSave() {
            const prouctOrderSlippageNotesRequest = this.workOrderService.patchWorkOrder(this.workOrder.WorkOrderID, {
                UpdateProductOrderSlippageNote: {
                    ProductOrderID: this.productOrder.ProductOrderID,
                    SlippageNotes: this.productOrder.SlippageNotes
                }
            });

            const statusChangeRequest = this.productOrder.StatusHistory
                .filter(p => p.IsNew)
                .map(status => this.mapProductOrderStatusRequest(status));
            this.utilityService.showLoading();
            this.$q.all([prouctOrderSlippageNotesRequest, statusChangeRequest])
                .then(p => {
                    this.utilityService.hideLoading();
                    this.close()
                })
                .catch(q => {
                    this.utilityService.hideLoading();
                    alert("Saving failed")
                });
        }

        mapProductOrderStatusRequest(status) {
            return this.workOrderService.patchWorkOrder(this.workOrder.WorkOrderID, {
                ChangeProductOrderStatus: {
                    ProductOrderID: this.productOrder.ProductOrderID,
                    EffectiveDate: status.EffectiveDate,
                    ProductOrderStatusID: status.Status.ProductOrderStatusID,
                    WorkOrderID: this.workOrder.WorkOrderID
                }
            });
        }
    }
}
